import React from "react";
import Dropdown from "antd/lib/dropdown";
import { TDropDown, TButton } from "./interface";

import "./index.less";

const Button: TButton = ({ className = "", children, ...rest }) => (
	<Dropdown.Button className={`z-dropdown-button ${className}`} {...rest}>
		{children}
	</Dropdown.Button>
);

const ZDropdown: TDropDown = ({
	className = "",
	overlayClassName = "",
	overlay,
	children,
	disabled = false,
	...rest
}) => (
	<Dropdown
		className={`z-dropdown ${
			disabled ? "z-dropdown-disabled" : ""
		} ${className}`}
		overlayClassName={`z-dropdown-overlay ${overlayClassName}`}
		overlay={overlay}
		disabled={disabled}
		{...rest}
	>
		{children}
	</Dropdown>
);

ZDropdown.Button = Button;

export default ZDropdown;
